/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDisconnectIntegrationResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeDisconnectIntegrationRequest, serializeDisconnectIntegrationResponse, type DisconnectIntegrationRequest, type DisconnectIntegrationResponse, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/integrations/{integration-id}/disconnect
 */
export interface DisconnectRequestBuilder extends BaseRequestBuilder<DisconnectRequestBuilder> {
    /**
     * Hands the connection back: the provider is asked to revoke the tokens held for this organisation, so the integration stops being able to act until it is connected again through POST /api/integrations/{integrationId}/connect. The integration record itself survives — its configuration and display name are untouched, and this is not a delete. By default it is also switched off, so it does not sit there advertised as enabled with no tokens behind it; send disableIntegration false to leave the enabled flag alone. Disabling is reported separately in wasDisabled, because the disconnect succeeds even if switching it off does not. Disconnecting something already disconnected is not an error, so a retry after a failed attempt is safe.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DisconnectIntegrationResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: DisconnectIntegrationRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DisconnectIntegrationResponse | undefined>;
    /**
     * Hands the connection back: the provider is asked to revoke the tokens held for this organisation, so the integration stops being able to act until it is connected again through POST /api/integrations/{integrationId}/connect. The integration record itself survives — its configuration and display name are untouched, and this is not a delete. By default it is also switched off, so it does not sit there advertised as enabled with no tokens behind it; send disableIntegration false to leave the enabled flag alone. Disabling is reported separately in wasDisabled, because the disconnect succeeds even if switching it off does not. Disconnecting something already disconnected is not an error, so a retry after a failed attempt is safe.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: DisconnectIntegrationRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const DisconnectRequestBuilderUriTemplate = "{+baseurl}/api/integrations/{integration%2Did}/disconnect";
/**
 * Metadata for all the requests in the request builder.
 */
export const DisconnectRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: DisconnectRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createDisconnectIntegrationResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDisconnectIntegrationRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
